import { getCookie } from 'cookies-next';
import { useUserProfile } from 'hooks/useIdentifyAnalytics/helpers';
import { fetchFeatureFlags } from 'lib/amplitude/client';
import { DEFAULT_FLAGS } from 'lib/amplitude/constants';
import type { FeatureFlags } from 'lib/amplitude/types';
import { RIVT_TOKEN_COOKIE_NAME } from 'lib/middleware/constants';
import { useQuery } from 'react-query';

const AMPLITUDE_FLAGS_QUERY_KEY = 'amplitude-flags';

export const useAmplitudeFlags = () => {
  const rivtToken = getCookie(RIVT_TOKEN_COOKIE_NAME);

  const { data: userProfile } = useUserProfile(rivtToken);

  const queryFn = async () => fetchFeatureFlags(userProfile.uuid);

  return useQuery<FeatureFlags>({
    enabled: !!userProfile,
    placeholderData: DEFAULT_FLAGS,
    queryFn,
    queryKey: [AMPLITUDE_FLAGS_QUERY_KEY]
  });
};
